import { graphql } from 'react-relay';

/**
 * Fetches all agent sessions associated with comments on a given page.
 * Used by useCommentAgentSession to seed snapshot state on page load / page reload,
 * so the hook can immediately show the correct session state without waiting for a
 * new @-mention (chat-new pubsub) event.
 *
 * Source: Raman's graphql-central-schema PR #16497 — allCommentAgentSessions on Content type.
 *
 * Each node provides:
 *   - conversationId: feed into useCommentAgentSession
 *   - subentityId:    the comment ARI — maps back to a specific comment
 *   - agentSession.state: snapshot state (WORKING | ARTEFACT_READY | INPUT_REQUIRED | FAILED)
 *
 * Note: subentityId is exposed via a follow-up Sky Bridge PR. Until it lands, the
 * mapping from session → comment will need to come from another source.
 */
export const CommentAgentSessionsQuery = graphql`
	query CommentAgentSessionsQuery($pageId: ID!) {
		content(id: $pageId) {
			nodes {
				id
				allCommentAgentSessions {
					edges {
						node {
							conversationId
							subEntityId
							agentSession {
								state
							}
						}
					}
				}
			}
		}
	}
`;
